import type { Condition } from './flow.schema';

export const findDuplicateLabels = (
  conditions: Array<Condition>,
): Array<Condition> => {
  const labelMap = new Map<
    string,
    { seenTwice: boolean; originalEntity: Condition }
  >();
  const duplicates: Condition[] = [];

  for (const condition of conditions) {
    // Safely extract label from nested structure
    const label = condition.config.value?.details?.label;

    // Skip conditions without labels
    if (!label) {
      continue;
    }

    if (labelMap.has(label)) {
      duplicates.push(condition);
      const mapEntry = labelMap.get(label);
      if (!!mapEntry && !mapEntry.seenTwice) {
        duplicates.push(mapEntry.originalEntity);
        mapEntry.seenTwice = true;
      }
    } else {
      labelMap.set(label, { seenTwice: false, originalEntity: condition });
    }
  }

  return duplicates;
};
